module.exports = __webpack_public_path__ + "static/media/done-all.9939c626.svg";